export enum Breakpoints {
  TABLET = 781,
  NOTEBOOK = 1000,
  DESKTOP = 1320,
}
